// extracted by mini-css-extract-plugin
export default {"skeleton_loader":"skeleton_loader___tGZpW","skeleton_wrapper":"skeleton_wrapper___RKzEK"};